'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var NavLink = require('../../components/NavLink.js');
require('./NavList.scss.js');
var index = require('../../../../../node_modules/classnames/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var defaultItem = {
    title: '',
    position: 'left',
    target: '_self',
    type: 'redirect',
};
var NavList = function (props) {
    var item = props.item, onMouseLeave = props.onMouseLeave, onMouseOver = props.onMouseOver, isShowChild = props.isShowChild, isSelected = props.isSelected;
    return (React__default['default'].createElement("li", { className: index['default']('nlist-root', isSelected && 'nlist-selected', item.position === 'right' ? 'nlist-right' : 'nlist-left'), onMouseOver: onMouseOver, onMouseLeave: onMouseLeave },
        React__default['default'].createElement(NavLink.NavLink, { item: item, isWithStyle: true }),
        isShowChild && item.childItems && (React__default['default'].createElement("ul", { className: "nlist-child_item" }, item.childItems.map(function (ci) { return (React__default['default'].createElement("li", { key: "nb-" + ci.title, className: "child_list" },
            React__default['default'].createElement(NavLink.NavLink, { item: ci }))); })))));
};
NavList.defaultProps = {
    item: defaultItem,
    isShowChild: false,
    isSelected: false,
};

exports.NavList = NavList;
//# sourceMappingURL=NavList.js.map
